import {Component, computed, input} from '@angular/core';
import {chunk} from 'lodash';

@Component({
    selector: 'wci-image-marquee',
    imports: [],
    templateUrl: './image-marquee.component.html',
    styles: `
        :host {
            display: block;
        }

        :host * {
            pointer-events: none;
            touch-action: none;
        }

        .companies-strip {
            width: 100%;
            overflow: hidden;
        }

        .strip-content {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }

        .company-logos {
            display: flex;
            animation: slide 25s linear infinite;
            animation-direction: normal;
            gap: 0.5rem;
        }

        .company-logos.reversed {
            animation-direction: reverse;
        }

        .logo-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 8rem;
            margin: auto;
        }

        .logo-item img {
            width: 100%;
            aspect-ratio: 8 / 5;
        }

        @keyframes slide {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-100%);
            }
        }

        @media (max-width: 768px) {
            .logo-item {
                min-width: 100px;
            }
        }
    `,
})
export class ImageMarqueeComponent {
    images = input.required<{ image: string; name: string }[]>();

    protected dupedImageRows = computed(() => {
        const all = this.images();
        const chunked = chunk(all, all.length / 7);

        return chunked.map((chunk) => [...chunk]);
    });
}
